import * as React from 'react';
import { IK3ContainerCsrAndWashCareViewProps } from './k3-container-csr-and-wash-care';

export default (props: IK3ContainerCsrAndWashCareViewProps) => {
    return <div />;
};
